import { supabase } from "@/integrations/supabase/client";

export type UpdateType = 'csv_import' | 'manual_add' | 'manual_edit' | 'delete_all';

interface RecordImportMetadataParams {
  tableName: string;
  entityType?: string;
  updateType: UpdateType;
  recordsAffected?: number;
}

export async function recordImportMetadata({
  tableName,
  entityType,
  updateType,
  recordsAffected = 1,
}: RecordImportMetadataParams): Promise<void> {
  try {
    // Get current user
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) {
      console.error('No user found when recording import metadata');
      return;
    }

    // Get user profile for name
    const { data: profile } = await supabase
      .from('user_profiles')
      .select('full_name')
      .eq('id', user.id)
      .single();

    // Use email if full_name is empty or matches a role name
    let userName = profile?.full_name || user.email || 'Usuário Desconhecido';
    
    const roleNames = ['admin', 'Admin', 'editor', 'Editor', 'cliente', 'Cliente', 'guest', 'Guest'];
    if (roleNames.includes(userName)) {
      userName = user.email || 'Usuário Desconhecido';
    }

    // Insert metadata record
    const { error } = await supabase
      .from('import_metadata')
      .insert({
        table_name: tableName,
        entity_type: entityType,
        updated_by_user_id: user.id,
        updated_by_name: userName,
        update_type: updateType,
        records_affected: recordsAffected,
      });

    if (error) {
      console.error('Error recording import metadata:', error);
    }
  } catch (error) {
    console.error('Error in recordImportMetadata:', error);
  }
}
